<template>
  <div>
    <slot v-bind="slotProps" />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  throttle: {
    type: [Number, Boolean],
    default: 200,
  },
})

const emit = defineEmits(['update'])

const screen = useScreen(props.throttle)

const slotProps = computed(() => ({
  width: screen.windowWidth.value,
  xs: screen.xs.value,
  sm: screen.sm.value,
  md: screen.md.value,
  lg: screen.lg.value,
  xl: screen.xl.value,
  '2xl': screen['2xl'].value,
  '3xl': screen['3xl'].value,
  isWider: screen.isWider,
  isNarrower: screen.isNarrower,
  isBetween: screen.isBetween,
}))

watch(screen.windowWidth, (newWidth) => {
  if (newWidth !== null) {
    emit('update', newWidth)
  }
})
</script>